let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c5krk"), load("heZTL")]).then(() => parcelRequire('lCh01'));